"use client";

import React from "react";
const statsData = [{
  label: "TOTAL H100 CAPACITY",
  value: "12,400+"
}, {
  label: "ACTIVE GPU CLUSTERS",
  value: "48"
}, {
  label: "MW POWER DEPLOYED",
  value: "120.5"
}];
export default function ComputeInfrastructureStats() {
  return;
}